module.exports = __webpack_public_path__ + "img/fg.b0cf30e9.png";